import React from "react";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

import { useSelector } from "react-redux";

const ZeroVisitMembers = () => {
  const { zeroVisitMembersNumber, zeroVisitMembersRawDataLink, totalZeroVisitMembersNumber } =
    useSelector((state) => state.membership.zeroVisitMembers);
  const { dailyMembershipFeature } = useSelector(
    (state) => state.membership.currentUser
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay
        value={dailyMembershipFeature ? zeroVisitMembersNumber : 0}
        url={zeroVisitMembersRawDataLink}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={totalZeroVisitMembersNumber}
        toolTip="Percentage change from previous month"
        showBorder
        positiveColor="#c7343e"
        negativeColor="#21e981"
      />
    </>
  );
};

export default ZeroVisitMembers;
